import { render } from "./CustomSearchComUf.vue?vue&type=template&id=8b71fe42&ts=true"
import script from "./CustomSearchComUf.vue?vue&type=script&lang=ts"
export * from "./CustomSearchComUf.vue?vue&type=script&lang=ts"

import "./CustomSearchComUf.vue?vue&type=style&index=0&id=8b71fe42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__